import type { TableCellFormatter } from "@/components/explore/ExploreTable";
import type { TooltipFormatter } from "@/components/explore/Heatmap";

function formatGateLoungeTimeLabel(timeLabel: string): string {
  const trimmed = timeLabel.trim();
  const match = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (match) {
    const h = parseInt(match[1], 10);
    const m = match[2];
    if (!Number.isNaN(h)) {
      return `${h}:${m}`;
    }
  }
  return trimmed;
}

function gateLoungeDisplayName(zoneName: string): string {
  const t = zoneName.trim();
  if (/^gate\s/i.test(t)) {
    return t;
  }
  return `Gate ${t}`;
}

export const gateLoungePaxTooltipFormatter: TooltipFormatter = ({
  zoneName,
  timeLabel,
  value,
}) => {
  const gate = gateLoungeDisplayName(zoneName);
  const time = formatGateLoungeTimeLabel(timeLabel);
  const count = Math.round(value);
  return `<b>${gate} — ${time}</b><br/>${count.toLocaleString()} passengers expected in lounge`;
};

export const bagBreakdownTooltipFormatter: TooltipFormatter = ({
  zoneName,
  timeLabel,
  value,
  suffixText,
}) => {
  let tooltipText = `<b>${zoneName} @ ${timeLabel}</b><br/>`;
  tooltipText += `<b>Total: ${value} ${suffixText}</b>`;

  if (value > 0) {
    const standardBags = Math.round(value * 0.75);
    const internationalBags = Math.round(value * 0.2);
    const oversizedBags = value - standardBags - internationalBags;

    tooltipText += `<br/><br/>`;
    tooltipText += `<span style="color: #90EE90">●</span> Standard: ${standardBags} (75%)<br/>`;
    tooltipText += `<span style="color: #87CEEB">●</span> International: ${internationalBags} (20%)<br/>`;
    tooltipText += `<span style="color: #FFD700">●</span> Oversized: ${oversizedBags} (5%)`;
  }

  return tooltipText;
};

export const bagBreakdownCellFormatter: TableCellFormatter = ({ value }) => {
  const standardBags = Math.round(value * 0.75);
  const internationalBags = Math.round(value * 0.2);
  const oversizedBags = value - standardBags - internationalBags;

  let tooltip = `<b>Total: ${value} Bags</b><br/><br/>`;
  tooltip += `<span style="color: #90EE90">●</span> Standard: ${standardBags} (75%)<br/>`;
  tooltip += `<span style="color: #87CEEB">●</span> International: ${internationalBags} (20%)<br/>`;
  tooltip += `<span style="color: #FFD700">●</span> Oversized: ${oversizedBags} (5%)`;

  return {
    display: value.toLocaleString(),
    tooltip: value > 0 ? tooltip : undefined,
  };
};
